export interface PaymentMethodModel {
    id: number;
    operationType: PaymentOperationType;
    systemType: PaymentSystemType;
    titleRu: string;
    titleEn?: string;
    image: string;
    currencies: string[];
    sort: number;
    minAmount: number;
    maxAmount: number;
    ourCommissionPercent: number;
    providerCommissionPercent: number;
    providerFixedCommission: number;
    providerMinCommission?: number;
    requiredFields?: PaymentExtraFields;
    tagRu?: string;
    tagEn?: string;
    externalRef?: string;
    isActive: boolean;
    calculateWithdrawalTime?: boolean;
}

export enum PaymentOperationType {
    Deposit = 1,
    Withdraw = 2
}

export enum PaymentSystemType {
    Tome = 0,
    GameMoney = 1
}

export enum PaymentExtraFields {
    None = 0,
    Phone = 1 << 0,
    Email = 1 << 1,
    CardNumber = 1 << 2,
    Bank = 1 << 3,
    CryptoWallet = 1 << 4,
    SteamLogin = 1 << 5,
    Purse = 1 << 6,
    CardExpiryYear = 1 << 7,
    CardExpiryMonth = 1 << 8,
    CardCsc = 1 << 9
}

export const PaymentExtraFieldDescription: Readonly<Record<string, string>> = Object.freeze({
    Phone: 'Телефон',
    Email: 'Email',
    CardNumber: 'Номер карты',
    Bank: 'Банк',
    CryptoWallet: 'Криптокошелек',
    SteamLogin: 'Steam логин',
    Purse: 'Кошелек',
    CardExpiryYear: 'Срок действия карты, год, YY.',
    CardExpiryMonth: 'Срок действия карты, месяц, MM.',
    CardCsc: 'Код CVC',
});

export const getPaymentExtraFieldLabel = (key: string): string => PaymentExtraFieldDescription[key] ?? key;


